export default "__VITE_ASSET__ChfDjppC__"